module.exports = __webpack_public_path__ + "static/academic-major.41ada28a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/academic-major.jpg
// module id = 7150
// module chunks = 40275710597918